const formStyle = {
    control: (base: any, state: any) => ({
        ...base,
        border: "none",
        borderRadius: "0px",
        backgroundColor: "transparent",
        boxShadow: "none",
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        pointerEvents: "auto",
        overflowY: "auto",
    }),
    placeholder: (base: any, state: any) => ({
        ...base,
        color: state.isFocused ? "var(--input-color)" : "#000",
        backgroundColor: "transparent",
    }),
    menu: (base: any) => ({
        ...base,
        overflowY: "auto",
        scrollbarWidth: "none",
        color: "var(--text-color)",
        zIndex: 1,
    }),
    menuList: (base: any) => ({
        ...base,
        maxHeight: "160px",
    }),
    menuPortal: (base: any) => ({
        ...base,
        zIndex: 2,
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isFocused ? "#eee" : "",
        color: "var(--text-color)",
        fontWeight: state.isSelected ? "bold" : "",
    }),
    singleValue: (base: any, state: any) => ({
        ...base,
        color: state.selectProps.menuIsOpen ? "var(--input-color)" : state.isSelected ? "var(--text-color)" : "var(--text-color)",
    }),
    multiValueRemove: (base: any) => ({
        ...base,
        color: 'red',
    }),
    dropdownIndicator: (base: any) => ({
        ...base,
        color: "var(--text-color)",
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
};

export default formStyle;